export default __webpack_public_path__ + "static/media/25-marina-gallo-ophiuchus-jewels-paine-chile-travel-diary.7fb422be.jpg";